const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getMisTareasResponsable = async (filtro = 1) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    // Verificar que el usuario tenga rol 3
    const { jwtDecode } = await import('jwt-decode');
    const decodedToken = jwtDecode(token);
    if (decodedToken.rolId !== '3') {
      return { success: false, message: 'Acceso denegado. Se requiere rol de soporte técnico.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/mis-tareas-responsable?filtro=${filtro}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas asignadas.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas asignadas:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

export const getMisTareasResponsablePorCalificacion = async (calificada) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const { jwtDecode } = await import('jwt-decode');
    const decodedToken = jwtDecode(token);
    // Permitir roles 1 (admin) y 3 (soporte)
    if (decodedToken.rolId !== '3' && decodedToken.rolId !== '1') {
      return { success: false, message: 'Acceso denegado. Se requiere rol 1 o 3.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/mis-tareas-responsable?calificada=${calificada}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al obtener las tareas por calificación.' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener las tareas por calificación:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
};

// Cambiar el estado de una tarea (PUT /api/tareas/{tareaId}/estado)
export const updateEstadoTarea = async (tareaId, nuevoEstado) => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: 'Token no encontrado. Inicie sesión.' };
    }

    const response = await fetch(`${API_BASE_URL}tareas/${tareaId}/estado`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ nuevoEstado }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      return { success: false, message: errorData.message || 'Error al cambiar el estado de la tarea.' };
    }

    if (response.status === 204) {
      return { success: true, data: null };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error('Error al cambiar el estado de la tarea:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 